import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/our-work', label: 'Our Work' },
    { path: '/adopt', label: 'Adopt' },
    { path: '/volunteer', label: 'Volunteer' },
    { path: '/newsletter', label: 'Newsletter' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/logo.svg" 
              alt="Animal Care India" 
              className="h-10 md:h-14 w-auto max-w-[180px] md:max-w-[220px]" 
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-warm-amber bg-amber-50'
                    : 'text-gray-700 hover:text-warm-amber hover:bg-amber-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-3">
            <Link to="/emergency">
              <Button variant="outline" className="border-safety-red text-safety-red hover:bg-safety-red hover:text-white transition-colors duration-200">
                Emergency
              </Button>
            </Link>
            <Link to="/donate" target="_blank" rel="noopener noreferrer">
              <Button className="bg-warm-amber hover:bg-amber-600 text-white transition-colors duration-200">
                Donate Now
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <nav className="container mx-auto px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-warm-amber bg-amber-50'
                    : 'text-gray-700 hover:text-warm-amber hover:bg-amber-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-4 space-y-2">
              <Link to="/emergency" onClick={() => setIsMenuOpen(false)}>
                <Button variant="outline" className="w-full border-safety-red text-safety-red hover:bg-safety-red hover:text-white transition-colors duration-200">
                  Emergency
                </Button>
              </Link>
              <Link to="/donate" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-warm-amber hover:bg-amber-600 text-white transition-colors duration-200">
                  Donate Now
                </Button>
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;